import { Grid, Link, Box } from '@mui/material';
import { HeaderShort, JFormik } from '../components';
import { routeNames } from '../config';
import * as Yup from 'yup';

export interface SignupProps {
  signup?: Function;
  navigate?: Function;
}

export const Signup = ({ signup, navigate }: SignupProps) => {
  return (
    <Box sx={{ bgcolor: 'rgba(249,255,243,1)', paddingX: { xs: 2, sm: 3 } }}>
      <HeaderShort position="fixed" />
      <Grid
        container
        sx={{
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          height: '100vh',
          minHeight: 820,
        }}
      >
        <Grid item xs={12} sm={8} md={6} lg={5} xl={4}>
          <JFormik
            initialValues={(resource: any) => ({ email: '', password: '' })}
            validationSchema={Yup.object({
              firstname: Yup.string().required('First Name is required'),
              lastname: Yup.string().required('Last Name is required'),
              email: Yup.string()
                .required('Email is required')
                .email('Invalid email address'),
              password: Yup.string().required('Password is required'),
              passwordConfirm: Yup.string()
                .oneOf(
                  [Yup.ref('password'), null],
                  'Please make sure your passwords match'
                )
                .required('Confirm password is required'),
            })}
            handleSubmit={async (values: any) => {
              if (signup) {
                await signup(values);
                navigate && navigate(routeNames.LOGIN);
              }
            }}
            form={[
              {
                name: 'h4',
                itemType: 'typography',
                label: 'Create new subscription',
                jItemProps: {
                  variant: 'h4',
                  sx: { textAlign: 'center', fontSize: { xs: 28, sm: 34 } },
                },
              },
              {
                name: 'subtitle1',
                itemType: 'typography',
                label: `If you want to join another existing subscription ask for an invite or use your company email!'`,
                jItemProps: {
                  variant: 'subtitle1',
                  color: 'textSecondary',
                  sx: {
                    textAlign: 'center',
                    marginTop: -1,
                    marginBottom: 3,
                    lineHeight: 1.5,
                  },
                },
              },
              {
                name: 'firstname',
                itemType: 'textfield',
                label: 'First Name',
              },
              {
                name: 'lastname',
                itemType: 'textfield',
                label: 'Last Name',
              },
              {
                name: 'email',
                itemType: 'textfield',
                label: 'Email',
              },
              {
                name: 'password',
                itemType: 'textfield',
                jItemProps: { type: 'password' },
                label: 'Password',
              },
              {
                name: 'passwordConfirm',
                itemType: 'textfield',
                jItemProps: { type: 'password' },
                label: 'Password Confirm',
              },
              {
                name: 'submit',
                itemType: 'button',
                jItemProps: { type: 'submit' },
                label: 'Create Account',
              },
            ]}
          />
          <Link
            component="button"
            variant="body1"
            sx={{ mt: 5 }}
            onClick={() => {
              navigate
                ? navigate(routeNames.LOGIN)
                : console.info('back_to_signin');
            }}
          >
            Back to Sign in
          </Link>
        </Grid>
      </Grid>
    </Box>
  );
};
